export const TRANSACTION_HISTORY_STATUS_ENUM = {
    INIT: 'init',
    PROCESSED: 'processed',
    ERROR: 'error',
    REJECTED: 'rejected',
    PENDING: 'pending',
};
